import { useState } from 'react'
import {
  Box,
  Stack,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'

import { RecoveryKey } from './RecoveryKey'

export const Settings = () => {
  const [settingsSection, setSettingsSection] = useState('recoveryKey')

  const selectPage = () => {
    switch (settingsSection) {
    case 'recoveryKey':
      return (
        <RecoveryKey />
      )
    default:
      return ''
    }
  }

  return (
    <Stack
      height="100%"
      width="100%"
      position="relative"
      overflow="hidden"
    >
      <Stack
        height="40px"
        alignItems="center"
        justifyContent="center"
        marginY="10px"
        display="flex"
        direction="row"
      >
        <Box
          padding="5px"
          borderRadius="full"
          backgroundColor={settingsSection === 'recoveryKey' ? '#ebc700' : 'transparent'}
          cursor="pointer"
          onClick={() => setSettingsSection('recoveryKey')}
        >
          <Text color={COLORS.white}>
            Recovery Key
          </Text>
        </Box>

        <Box
          padding="5px"
          borderRadius="full"
          backgroundColor={settingsSection === 'qrCode' ? '#ebc700' : 'transparent'}
          cursor="pointer"
          onClick={() => setSettingsSection('qrCode')}
        >
          <Text color={COLORS.white}>
            QR Code
          </Text>
        </Box>
      </Stack>

      <Box>{selectPage()}</Box>
    </Stack>
  )
}
